import { Box } from "rebass/styled-components";
import { LoadingSkeleton } from "MVVM/Components/Skeloton";

export const LoadingContent = () => {
  return (
    <>
      <Box my={2}>
        <LoadingSkeleton width="180px" height="16px" />
      </Box>
      <Box my={2}>
        <LoadingSkeleton width="100%" height="40px" />
      </Box>
      <Box my={2}>
        <LoadingSkeleton width="200px" height="24px" />
      </Box>
    </>
  );
};
